import React, { PropTypes } from 'react'
import classnames from 'classnames'

export function Loading() {
    return <div>Loading, please wait...</div>
}

export function NoItemsTableRow({ colSpan }) {
    return (
        <tr className="table-row">
            <td className="table-cell table-cell--centered" colSpan={ colSpan }>
                Sorry, no items found.
            </td>
        </tr>
    )
}
NoItemsTableRow.propTypes = {
    colSpan: PropTypes.number.isRequired,
}

export function FormattedNumber({ prefix, suffix, value }) {
    const number = parseFloat(value)

    return (
        <span>
            { prefix }
            { number.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }
            { suffix }
        </span>
    )
}
FormattedNumber.propTypes = {
    prefix: PropTypes.node,
    suffix: PropTypes.node,
    value: PropTypes.number.isRequired,
}

export function Icon(props) {
    const wrapProps = {
        className: 'icon',
    }

    if (props.list) {
        wrapProps.className = ''
    }
    if (props.label) {
        wrapProps['aria-label'] = props.label
        wrapProps.title = props.label
    }
    if (props.className) {
        wrapProps.className += ` ${ props.className }`
    }

    const classes = classnames(
        'fa',
        {
            'fa-lg': props.large,
            'fa-2x': props.double,
            'fa-3x': props.triple,
            'fa-4x': props.quad,
            'fa-5x': props.quint,
            'fa-fw': props.fixed,
            'fa-li': props.list,
            'fa-pull-left': props.left,
            'fa-pull-right': props.right,
            'fa-bordered': props.bordered,
            'fa-spin': props.spin,
            'fa-pulse': props.pulse,
            'fa-inverse': props.inverse,
        },
        `fa-${ props.icon }`,
    )

    return (
        <span { ...wrapProps }>
            <i aria-hidden="true" className={ classes } />
            { props.text ? ` ${ props.text }` : '' }
        </span>
    )
}
Icon.propTypes = {
    bordered: PropTypes.bool,
    className: PropTypes.string,
    double: PropTypes.bool,
    fixed: PropTypes.bool,
    icon: PropTypes.string.isRequired,
    inverse: PropTypes.bool,
    label: PropTypes.string,
    large: PropTypes.bool,
    left: PropTypes.bool,
    list: PropTypes.bool,
    pulse: PropTypes.bool,
    quad: PropTypes.bool,
    quint: PropTypes.bool,
    right: PropTypes.bool,
    spin: PropTypes.bool,
    text: PropTypes.string,
    triple: PropTypes.bool,
}

export function BooleanList({ options, selected }) {
    return (
        <ul className="list list--unstyled">
            { options.map((item) => (
                <li key={ item.value }>
                    <BooleanItem label={ item.label } selected={ selected.includes(item.value) } />
                </li>
            )) }
        </ul>
    )
}
BooleanList.displayname = 'BooleanList'
BooleanList.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export function BooleanItem({ label, selected }) {
    return (
        <span>
            <Icon
                className={ `label label--${ selected ? 'success' : 'danger' }` }
                fixed
                icon={ selected ? 'check' : 'times' }
            />
            { label }
        </span>
    )
}
BooleanItem.displayName = 'BooleanItem'
BooleanItem.propTypes = {
    label: PropTypes.node,
    selected: PropTypes.bool.isRequired,
}



// WEBPACK FOOTER //
// ./app/components/misc.js